import { render, staticRenderFns } from "./PdfReport.vue?vue&type=template&id=f79957ca&scoped=true&"
import script from "./PdfReport.vue?vue&type=script&lang=js&"
export * from "./PdfReport.vue?vue&type=script&lang=js&"
import style0 from "./PdfReport.vue?vue&type=style&index=0&id=f79957ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79957ca",
  null
  
)

/* custom blocks */
import block0 from "./PdfReport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f79957ca')) {
      api.createRecord('f79957ca', component.options)
    } else {
      api.reload('f79957ca', component.options)
    }
    module.hot.accept("./PdfReport.vue?vue&type=template&id=f79957ca&scoped=true&", function () {
      api.rerender('f79957ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/report/PdfReport.vue"
export default component.exports